import React, {memo} from 'react';
import FormikTextField from '../../../../../../components/inputs/FormikTextField';
import {Holiday, IHoliday} from '../../../../../../types/Holiday';
import FormikDatePicker from '../../../../../../components/inputs/FormikDatePicker';
import DialogComponent from 'components/Dialog';
import {DialogTypes} from '../../../../../../common/names';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import {Grid} from '@mui/material';
import Formik from 'components/hook-form/Formik';
import {useTranslation} from 'react-i18next';
import {ReactFChildrenProps} from 'types/react/ReactFChildrenProps';

type AddHolidayDialogProps = {
   onSubmit: (values: IHoliday) => void;
   onClose: () => void;
};

const AddHolidayDialog: ReactFChildrenProps<AddHolidayDialogProps> = memo((props) => {
   const {onSubmit, onClose} = props;
   const {t} = useTranslation();

   return (
      <DialogComponent maxWidth="md" header={DialogTypes.AddHoliday.dialogName} close={onClose}>
         <Formik onSubmit={onSubmit} initialValues={Holiday.cast({})} validationSchema={Holiday}>
            <>
               <Grid container spacing={3}>
                  <Grid item sm={12} lg={8}>
                     <FormikTextField autoFocus name="name" placeholder={t('Holiday Name')} />
                  </Grid>
               </Grid>
               <Grid container spacing={3}>
                  <Grid item sm={12} lg={8}>
                     <div>
                        <FormikDatePicker name="date" label={t('Holiday Date')} />
                     </div>
                  </Grid>
               </Grid>
               <Grid container spacing={3} justifyContent="center">
                  <Grid item>
                     <FormFooterButtons cancel={onClose} />
                  </Grid>
               </Grid>
            </>
         </Formik>
      </DialogComponent>
   );
});

export default AddHolidayDialog;
